<template>
  <div
    style="height: calc(100vh - 88px); background-color: #fff"
    class="xiugai-advanced"
  >
    <p class="title">账号修改</p>
    <div class="xiugai">
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="tabIndex == 0 ? rules : rule"
      >
        <div class="modify">
          <p>
            <span
              v-for="(item, index) in tit"
              :key="index"
              :class="index == tabIndex ? 'bg_color' : ''"
              @click="tabSel(index)"
              >{{ item }}
              <hr :class="index == tabIndex ? 'bg_color_hr' : ''" />
            </span>
          </p>
        </div>

        <div v-if="tabIndex == 0">
          <el-form-item prop="primary_phone">
            <el-input
              v-model="ruleForm.primary_phone"
              placeholder="请输入原手机号"
            ></el-input>
          </el-form-item>
          <el-form-item prop="new_phone">
            <el-input
              v-model="ruleForm.new_phone"
              placeholder="请输入新手机号"
            ></el-input>
          </el-form-item>
          <el-form-item prop="pass">
            <el-input
              type="password"
              show-password
              v-model="ruleForm.pass"
              placeholder="请输入密码"
            >
            </el-input>
          </el-form-item>
        </div>
        <div v-if="tabIndex == 1">
          <el-form-item prop="primary_pass">
            <el-input
              type="password"
              show-password
              v-model="ruleForm.primary_pass"
              placeholder="请输入原密码"
            ></el-input>
          </el-form-item>
          <el-form-item prop="new_pass">
            <el-input
              type="password"
              show-password
              v-model="ruleForm.new_pass"
              placeholder="请输入现密码"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="ok_pass">
            <el-input
              @blur="blur"
              type="password"
              show-password
              v-model="ruleForm.ok_pass"
              placeholder="请确定密码"
            >
            </el-input>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary" @click="this_ok">确定</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { isphone } from "@/filters";
import { updatePhone } from "@/api/open";
import store from "@/store";
export default {
  data() {
    return {
      tit: ["修改手机号", "修改密码"],
      tabIndex: 0,
      ruleForm: {
        primary_phone: "", //15100000000
        new_phone: "", //现手机号
        pass: "", //密码

        primary_pass: "", //原密码
        new_pass: "", //现密码
        ok_pass: "", //确定密码
      },
      rules: {
        primary_phone: isphone(),
        new_phone: isphone(),
        pass: [
          { required: true, trigger: "change", message: "密码不能为空" },
          {
            pattern:
              /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,.\/]).{8,16}$/,
            message: "请输入长度8-16位，包括数字、大/小写字线、特殊字符的密码",
          },
        ],
      },
      rule: {
        primary_pass: [
          { required: true, trigger: "blur", message: "密码不能为空" },
          {
            pattern:
              /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,.\/]).{8,16}$/,
            message: "请输入长度8-16位，包括数字、大/小写字线、特殊字符的密码",
          },
        ],
        new_pass: [
          { required: true, trigger: "blur", message: "密码不能为空" },
          {
            pattern:
              /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,.\/]).{8,16}$/,
            message: "请输入长度8-16位，包括数字、大/小写字线、特殊字符的密码",
          },
        ],
        ok_pass: [{ required: true, trigger: "blur", message: "密码不能为空" }],
      },
    };
  },
  computed: { ...mapGetters(["userInfo"]) },
  methods: {
    tabSel(index) {
      this.tabIndex = index;
      this.$refs.ruleForm.resetFields();
    },
    this_ok() {
      this.$refs.ruleForm.validate((valid) => {
        console.log(this.rules);
        if (valid) {
          console.log("成功");
          let parmas = {};
          if (this.tabIndex == 0) {
            parmas = {
              phone: this.ruleForm.primary_phone,
              phoneCurrent: this.ruleForm.new_phone,
              password: this.$md5(this.ruleForm.pass), //
              type: this.tabIndex + 1,
              user_id: this.userInfo.id,
            };
          } else {
            parmas = {
              password: this.$md5(this.ruleForm.primary_pass), //原密码
              passwordCurrent: this.$md5(this.ruleForm.new_pass), //现密码
              passwordConfirm: this.$md5(this.ruleForm.ok_pass), //确定密码
              type: this.tabIndex + 1,
              user_id: this.userInfo.id,
            };
          }

          updatePhone(parmas).then((res) => {
            console.log(res);
            if (res.code == 200) {
              this.$message.success(res.msg);
              setTimeout(() => {
                store.dispatch("LogOut").then(() => {
                  sessionStorage.clear();
                  location.href = "/login";
                });
              }, 1000);
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          console.log("失败");
        }
      });
    },
    blur() {
      console.log(this.ruleForm.new_pass);
      console.log(this.ruleForm.ok_pass);
      if (this.ruleForm.new_pass !== this.ruleForm.ok_pass) {
        this.$message.error("两次密码不一致");
      }
    },
  },
  mounted() {},
  activated() {},
  watch: {},
};
</script>

<style lang="scss" scoped>
.xiugai-advanced {
  display: flex;
  padding: 10px 20px;
  // align-items: center;
  // padding-top: 10vh;
  // justify-content: center;
  /deep/.el-form-item__content {
    display: flex;
  }
  .pass {
    position: relative;
    margin: 15px 0;
    /deep/.el-input__inner {
      padding-right: 75px;
    }
    span {
      position: absolute;
      right: 0;
      bottom: -2px;
      transform: translate(-5%, -50%);
      cursor: pointer;
      color: #c2c1c1;
    }
  }
  /deep/.el-button {
    width: 100%;
  }
}
.xiugai {
  width: 400px;
  // margin: 15vh auto;
  position: fixed;
  left: 50%;
  top: 25%;
  transform: translate(-50%, 0%);
}
.title {
  color: rgba(102, 102, 102, 100);
  font-size: 20px;
  margin-bottom: 25px;
}

.modify {
  p {
    line-height: 20px;
    display: flex;
    margin-bottom: 20px;
    span {
      display: inline-block;
      width: 50%;
      text-align: center;
      cursor: pointer;
      display: flex;
      align-items: center;
      flex-direction: column;
    }
  }
}
.bg_color_hr {
  width: 10%;
  margin-top: 5px;
  height: 2px;
  border-radius: 3px;
  background: $four-level-bj-color;
}
.bg_color {
  color: $four-level-bj-color;
  font-size: 16px;
}
</style>
